import { EMPTY_OBJECT } from '../../constants/common'

export function checkIsBirdviewActivityDone(item, activityDoneById) {
  return activityDoneById[item.id] ?? item.done
}

// `null` is a pending "remove all", so the presence of the key wins over `??`.
export function getBirdviewRequestAssignee(item, assigneeById) {
  return Object.hasOwn(assigneeById, item.id)
    ? assigneeById[item.id]
    : item.assignee
}

// A failed assign reloads the row's section to bring the server state back.
export function getBirdviewRowRequestActions({ requestActions, onReload }) {
  return requestActions
    ? {
        ...requestActions,
        onAssign: item => requestActions.onAssign(item, onReload),
      }
    : EMPTY_OBJECT
}

export function getBirdviewFlatNumberLabel(number, t) {
  if (number) {
    return `${t('DashboardBirdview.FlatNumberKey')} ${number}`
  }
}
